import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IOgnData } from '@ogn-tracker/common/build/ogn';
import { FollowingQuery } from 'src/app/store/following/state/following.query';
import { FollowingStore } from 'src/app/store/following/state/following.store';
import { SubSink } from 'subsink';
import { MessagesPopupComponent } from '../messages-popup/messages-popup.component';
import { AircraftTypeStringMap } from '@ogn-tracker/common/build/enum/aircraft-type';

@Component({
  selector: 'app-vehicle-popup',
  templateUrl: './vehicle-popup.component.html',
  styleUrls: ['./vehicle-popup.component.scss'],
})
export class VehiclePopupComponent implements OnInit, OnDestroy {
  constructor(
    private dialog: MatDialog,
    private store: FollowingStore,
    private query: FollowingQuery
  ) {}
  selectedVehicle: IOgnData;
  aircraftTypeStringMap = AircraftTypeStringMap;
  subs = new SubSink();
  ngOnInit(): void {
    this.subs.sink = this.query.select().subscribe((state) => {
      this.selectedVehicle = state.currentVechile;
    });
  }
  follow() {
    this.store.update((x) => ({
      ...x,
      followCenterVehicle: true,
    }));
  }
  send() {
    this.dialog.open(MessagesPopupComponent, {
      data: {deviceId: this.selectedVehicle.deviceId},
      width: '500px',
      height: '480px',
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
